import React from 'react';
import Table from 'react-bootstrap/Table';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import {Button} from '@material-ui/core';

import DelNav from './DelNav';
import SPUtilities from "../util/SPUtilities";
import SPCalc from "../util/SPCalc";
import RespUtils from "../util/RespUtils";
import IUtils from "./IUtils";

class DelInline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    this.takeToVote = this.takeToVote.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  render() {
    return (
      <div>
        <Table striped bordered size="sm">
          <tbody>
            <tr>
              <th align="left">Delegate Name: </th>
              <td align="left"> {IUtils.nameFormatterLong(this.props.delegate.name, this.props.delegate)}</td>
            </tr>
            <tr>
              <th align="left">Registered Name: </th>
              <td align="left"> {this.props.delegate.registeredName}</td>
            </tr>
            <tr>
              <th align="left">Rank: </th>
              <td align="left"> {this.props.delegate.ranking}</td>
            </tr>
            <tr>
              <th align="left">Live Votes: </th>
              <td align="left"> {IUtils.coinCountCellFormatter(this.props.delegate.totalWeightedVotes, this.props.delegate)}</td>
            </tr>
            <tr>
              <th align="left">Self Bond: </th>
              <td align="left"> {IUtils.coinCountCellFormatter(this.props.delegate.selfBond)}</td>
            </tr>
            <tr>
              <th align="left">Overall Status: </th>
              <td align="left"> {this.props.delegate.overallStatus}</td>
            </tr>
            <tr>
              <th align="left">Rewards Distribution: </th>
              <td align="left"> {IUtils.rewardsFormatter(this.props.delegate.hermesInd, this.props.delegate, null, this.props.hermesInd)}</td>
            </tr>
            <tr>
              <th align="left">Reward Plan: </th>
              <td align="left">{IUtils.getRiskyInd(this.props.delegate.risky)} {this.props.delegate.rewardPlan}</td>
            </tr>
            <tr>
              <th>Blended Share %</th>
              <td align="left"> {IUtils.percentFormatter(this.props.delegate.blendedShare, this.props.delegate)}</td>
            </tr>
            <tr>
              <th align="left">Current Productivity: </th>
              <td align="left"> {IUtils.productivityFormatter(this.props.delegate.currentProductivity, this.props.delegate)}</td>
            </tr>

            <tr>
              <th align="left">Votes Weight: </th>
              <td align="left"> {this.props.delegate.percent}</td>
            </tr>
            <tr>
              <th align="left">Status: </th>
              <td align="left"> {this.props.delegate.overallStatus}</td>
            </tr>
            <tr>
              <th align="left">Address: </th>
              <td align="left"> {this.props.delegate.address}</td>
            </tr>
            <tr>
              <th align="left">Badges: </th>
              <td align="left">
                {IUtils.getBadge(this.props.delegate.hermesInd, "https://web-native-staking-v2.b-cdn.net/bnbridge/hermes.svg", "Issues rewards automatically using Hermes")}
                {IUtils.getBadge(this.props.delegate.genesisInd, "https://iotexdesign.b-cdn.net/icon_genesis%20delegates.svg", "Delegate since Day 1")}
                {IUtils.getBadge(this.props.delegate.ambassdorInd, "https://iotexdesign.b-cdn.net/icon_ambassador%20delegates.svg", "Ambassador Delegate")}
              </td>
            </tr>
            <tr>
              <th align="left">Notes for community: </th>
              <td align="left"> {this.props.delegate.comments}</td>
            </tr>
            <tr>
              <th align="left">Last Updated: </th>
              <td align="left"> {SPUtilities.getLastUpdatedFromEpoch(this.props.delegate.lastUpdated)}</td>
            </tr>
          </tbody>
        </Table>

        <p><b>Delegate Performance</b></p>
        <Table striped bordered size="sm" >
          <thead>
            <tr>
              <th>Window</th>
              <th>Description</th>
              <th>{RespUtils.getShortLabel("Part Rate", "Consensus Part. Rate")}</th>
              <th>{RespUtils.getShortLabel("Prod Rate", "Production Rate")}</th>
              <th>{RespUtils.getShortLabel("Prod Index", "Production Index")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td align="left"> Short Term</td>
              <td align="left"> 8 Hours / 8 Epochs</td>
              <td align="left"> {this.props.delegate.shortElectionRate}</td>
              <td align="left"> {this.props.delegate.shortProdRate}</td>
              <td align="left"> {this.props.delegate.shortProdIndex}</td>
            </tr>
            <tr>
              <td align="left"> Daily</td>
              <td align="left"> 1 Day / 24 Epochs</td>
              <td align="left"> {this.props.delegate.dailyElectionRate}</td>
              <td align="left"> {this.props.delegate.dailyProdRate}</td>
              <td align="left"> {this.props.delegate.dailyProdIndex}</td>
            </tr>
            <tr>
              <td align="left"> Mid Term</td>
              <td align="left"> 10 Days / 240 Epochs</td>
              <td align="left"> {this.props.delegate.midElectionRate}</td>
              <td align="left"> {this.props.delegate.midProdRate}</td>
              <td align="left"> {this.props.delegate.midProdIndex}</td>
            </tr>
            <tr>
              <td align="left"> Long Term</td>
              <td align="left"> 30 Days / 720 Epochs</td>
              <td align="left"> {this.props.delegate.longElectionRate}</td>
              <td align="left"> {this.props.delegate.longProdRate}</td>
              <td align="left"> {this.props.delegate.longProdIndex}</td>
            </tr>
          </tbody>
        </Table>

        <hr/>
        <p><b>Delegate Status</b></p>
        <Table striped bordered size="sm" >
          <thead>
            <tr>
              <th>Category</th>
              <th>Status</th>
              <th>Probated</th>
              <th>Overall Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td align="left"> {this.props.delegate.category != null ? this.props.delegate.category.replace("_", " ") : ""}</td>
              <td align="left"> {this.props.delegate.status}</td>
              <td align="left"> {this.props.delegate.probation}</td>
              <td align="left"> {this.props.delegate.overallStatus}</td>
            </tr>
          </tbody>
        </Table>

        <hr/>
        <p><b>Reward Sharing Details</b></p>
        <Table striped bordered size="sm" >
          <thead>
            <tr>
              <th>Block Reward Shared %</th>
              <th>Epoch Reward Shared %</th>
              <th>Foundation Reward Shared %</th>
              <th alt="For some of the delgates, rewards data is sourced manually for calculations. Please let us know if reward data is not in sync with IoTeX">Reward Data In Sync?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td align="left"> {IUtils.getRewardShare(this.props.delegate.blockRewardPortion, this.props.delegate)}</td>
              <td align="left"> {IUtils.getRewardShare(this.props.delegate.epochRewardPortion, this.props.delegate)}</td>
              <td align="left"> {IUtils.getRewardShare(this.props.delegate.foundationRewardPortion, this.props.delegate)}</td>
              <td align="left"> {IUtils.getFeeInSync(this.props.delegate.rewardPlanChanged)}</td>
            </tr>
          </tbody>
        </Table>
        <hr/>

        {!this.state.isLoading && !this.props.hideNav && this.renderValNav()}
      </div>
    );
  }

  renderValNav() {
    return (<DelNav delegateId={this.props.delegate.delegateId}/>);
  }

  takeToVote() {
    IUtils.takeToVote(this.props.delegate.id, this.props.delegate);
  }


}


export default DelInline;



// WEBPACK FOOTER //
// ./src/iotex/DelInline.js